<div class="tag-item__item" [ngClass]="{'tag-item__editing_tag': editTag}">
  <form [formGroup]="websiteTagsForm">
    <input class="ds-checkbox"
           formControlName="tagChecked"
           (change)="onTagChange(tag)"
           [ngClass]="{'ds-checkbox-partly': tag?.clickedValue === 'some'}"
           [checked]="tag?.clickedValue !== 'none'"
           type="checkbox" id="input_{{tag?.id}}">
    <label for="input_{{tag?.id}}" class="tag-item__tag-label">
      <p *ngIf="!editTag">{{tag?.title}}</p>
      <input type="text" placeholder="{{tag?.title}}" value="{{tag?.title}}"
             formControlName="tagTitle"
             id="tag_{{tag?.id}}" *ngIf="editTag"/>
    </label>
  </form>
  <div class="tag-item__edit-delete" [ngClass]="{'disabled': loading}">
    <span class="db-icon db-icon-edit" *ngIf="!editTag" (click)="focusOnTagValue(tag)"></span>
    <span class="db-icon db-icon-delete" *ngIf="!editTag" (click)="removeTag(tag)"></span>

    <span class="db-icon db-icon-success" *ngIf="editTag" (click)="editTagTest(tag)"></span>
    <span class="db-icon db-icon-error" *ngIf="editTag" (click)="editTag = false"></span>
  </div>
</div>
